export const SectionEnum = {
    REQUIRED: "required",
    ACHIEVED: "achieved",
};
